var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _PlayerPickerComponent_levelName_accessor_storage, _PlayerPickerComponent_levelAttemptNumber_accessor_storage;
import { LitElement, css, html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { fetchSavedMoves } from '../../game/connection/server-connection';
import { LEVELS } from '../../game/levels';
import { Sounds } from '../../lib/sounds';
import { choose } from '../../lib/util';
let PlayerPickerComponent = class PlayerPickerComponent extends LitElement {
    constructor() {
        super(...arguments);
        _PlayerPickerComponent_levelName_accessor_storage.set(this, undefined);
        _PlayerPickerComponent_levelAttemptNumber_accessor_storage.set(this, undefined);
        this.players = undefined;
        this.selectedPlayers = [];
    }
    get levelName() { return __classPrivateFieldGet(this, _PlayerPickerComponent_levelName_accessor_storage, "f"); }
    set levelName(value) { __classPrivateFieldSet(this, _PlayerPickerComponent_levelName_accessor_storage, value, "f"); }
    get levelAttemptNumber() { return __classPrivateFieldGet(this, _PlayerPickerComponent_levelAttemptNumber_accessor_storage, "f"); }
    set levelAttemptNumber(value) { __classPrivateFieldSet(this, _PlayerPickerComponent_levelAttemptNumber_accessor_storage, value, "f"); }
    render() {
        if (!this.players) {
            return;
        }
        const playerElements = this.players.map((player) => {
            const isSelected = this.selectedPlayers.includes(player);
            const selectedClass = isSelected ? 'player-card-selected' : '';
            return html `<summonable-player
                class="player-card ${selectedClass}"
                .player=${player}
                @click=${() => {
                if (isSelected) {
                    this.selectedPlayers = this.selectedPlayers.filter((p) => p !== player);
                }
                else {
                    this.selectedPlayers = [
                        ...this.selectedPlayers,
                        player,
                    ];
                }
                this.maybeSendSelected();
                const mainPlayerSong = window.game.playerVisualInfo?.songTrack ?? 'melody';
                Sounds.setSongs([mainPlayerSong, ...this.selectedPlayers.map(p => p.songTrack ?? 'melody')]);
            }}
            ></summonable-player>`;
        });
        return html `
            <h1>Summon a past player!</h1>
            <div class="players">${playerElements}</div>
            <div class="background"></div>
        `;
    }
    maybeSendSelected() {
        if (!this.levelName) {
            return;
        }
        const numPlayers = LEVELS.find((level) => level.name === this.levelName)?.numPlayers;
        if (!numPlayers) {
            return;
        }
        // Include this player in the number of players.
        if (this.selectedPlayers.length + 1 === numPlayers ||
            this.selectedPlayers.length === this.players?.length) {
            this.dispatchEvent(new CustomEvent('players-selected', {
                detail: this.selectedPlayers,
                bubbles: true,
                composed: true,
            }));
        }
    }
    async willUpdate(changedProperties) {
        console.log('player picker update');
        if (changedProperties.has('levelAttemptNumber')) {
            if (!this.levelName) {
                return;
            }
            this.players = undefined;
            this.selectedPlayers = [];
            const players = await fetchSavedMoves(this.levelName);
            // Fill any players without a track with something random
            const knownTracks = ['melody', 'bass', 'drums', 'chords'];
            players.forEach((player) => {
                if (!knownTracks.includes(player.songTrack ?? '')) {
                    player.songTrack = choose(knownTracks, Math.random);
                    console.log(`Chose random track for player ${player.player}: ${player.songTrack}`);
                }
            });
            this.players = players;
            console.log(`Got players for level ${this.levelName}: ${this.players}`);
            this.maybeSendSelected();
        }
    }
};
_PlayerPickerComponent_levelName_accessor_storage = new WeakMap();
_PlayerPickerComponent_levelAttemptNumber_accessor_storage = new WeakMap();
PlayerPickerComponent.styles = css `
        :host {
            display: flex;
            flex-direction: column;
            align-items: center;
        }

        .background {
            position: absolute;
            background-color: rgba(0, 0, 0, 0.5);
            top: 80%;
            left: 0;
            right: 0;
            bottom: 0;
        }

        .players {
            position: absolute;
            top: 70%;
            left: 0;
            right: 0;
            bottom: 0;
            display: flex;
            justify-content: center;
            align-items: stretch;
            z-index: 1;
        }

        .player-card-selected {
            border: 5px solid #ffe2ad;
        }

        .player-card {
            max-width: 30vw;
            transition: transform 0.1s;
        }

        .player-card:hover {
            transform: scale(1.1) translate(0, -10%);
        }

        .hidden {
            display: none;
        }
    `;
__decorate([
    property({ type: String })
], PlayerPickerComponent.prototype, "levelName", null);
__decorate([
    property({ type: Number })
], PlayerPickerComponent.prototype, "levelAttemptNumber", null);
__decorate([
    state()
], PlayerPickerComponent.prototype, "players", void 0);
__decorate([
    state()
], PlayerPickerComponent.prototype, "selectedPlayers", void 0);
PlayerPickerComponent = __decorate([
    customElement('player-picker')
], PlayerPickerComponent);
export { PlayerPickerComponent };
